import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronTriangleRightMedium"><Path d="M11.3932 8.13028C10.7426 7.58378 9.75 8.04631 9.75 8.89599V15.104C9.75 15.9537 10.7426 16.4162 11.3932 15.8697L15.0884 12.7657C15.5642 12.3661 15.5642 11.6339 15.0884 11.2343L11.3932 8.13028Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronTriangleRightMedium;
